import React from 'react';

import { IconButton, makeStyles } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

const resolveBackground = (theme, color) => {
  switch (color) {
    case 'white': {
      return theme.palette.common.white;
    }
    default: {
      return theme.palette.primary[50];
    }
  }
};

const useStyles = makeStyles(theme => ({
  header: {
    background: ({ background }) => resolveBackground(theme, background),
    minHeight: '132px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottomLeftRadius: theme.shape.borderRadiusLarge,
    borderBottomRightRadius: theme.shape.borderRadiusLarge,
    [theme.breakpoints.down('sm')]: {
      borderRadius: 0,
    },
    padding: theme.spacing(0, 2),
    textAlign: 'center',
    position: 'relative',
    width: '100%',
  },
  backButton: {
    position: 'absolute',
    left: theme.spacing(2),
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1,
  },
}));

const Jumbotron = ({ children, className, background, showBackButton, onBack }) => {
  const styles = useStyles({ background });
  const history = useHistory();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      history.goBack();
    }
  };

  return (
    <header className={clsx(styles.header, className)}>
      {showBackButton && (
        <IconButton className={styles.backButton} onClick={handleBack} size='small'>
          <ArrowBack />
        </IconButton>
      )}
      {children}
    </header>
  );
};

Jumbotron.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  background: PropTypes.oneOf(['white', 'primary']),
  showBackButton: PropTypes.bool,
  onBack: PropTypes.func,
};

Jumbotron.defaultProps = {
  children: null,
  className: '',
  background: 'primary',
  showBackButton: false,
  onBack: undefined,
};

export default Jumbotron;
